import { render, staticRenderFns } from "./BeneficiaryDetails.vue?vue&type=template&id=8fa1c9be"
import script from "./BeneficiaryDetails.vue?vue&type=script&lang=js"
export * from "./BeneficiaryDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports